export default __webpack_public_path__ + "static/media/dulces_detail4.5a484dea.jpg";